export default "__VITE_ASSET__iF45mvw8__"